__turbopack_context__.v({
  "highlighted": "Notices-module-scss-module__gJOtba__highlighted",
  "message": "Notices-module-scss-module__gJOtba__message",
  "root": "Notices-module-scss-module__gJOtba__root",
});
